module.exports = __webpack_public_path__ + "static/UIButtons@2x-3c39cea5ba7985580502bceb1b781320.jpg";